import React, { FC, useState } from 'react';
import { Snowfall } from 'react-snowfall';
import {
    getIsSnowEnabled,
    isWinterMonth,
    toggleSnowEnabled,
} from '../Header/utils';

type SnowEffectProps = {
    className?: string;
};

export const SnowEffect: FC<SnowEffectProps> = ({ className = '' }) => {
    const [isSnowEnabled, setIsSnowEnabled] = useState(getIsSnowEnabled);

    if (!isWinterMonth()) {
        return null;
    }

    const handleToggleSnow = () => {
        setIsSnowEnabled((prev) => toggleSnowEnabled(prev));
    };

    const buttonClass =
        'mr-3 flex items-center justify-center w-9 h-9 rounded-full text-base ' +
        'transition select-none ' +
        (isSnowEnabled
            ? 'bg-black/5 hover:bg-black/10'
            : 'bg-black/0 hover:bg-black/5 opacity-60');

    return (
        <>
            <button
                type="button"
                onClick={handleToggleSnow}
                aria-pressed={isSnowEnabled}
                aria-label={isSnowEnabled ? 'Выключить снег' : 'Включить снег'}
                title={isSnowEnabled ? 'Выключить снег' : 'Включить снег'}
                className={`${buttonClass} ${className}`}
            >
                <span className="text-[18px] leading-none">❄️</span>
            </button>

            {isSnowEnabled && (
                <Snowfall
                    snowflakeCount={300}
                    wind={[0, 0]}
                    radius={[0.5, 2.5]}
                    style={{
                        position: 'fixed',
                        width: '100vw',
                        height: '100vh',
                        zIndex: 99,
                        pointerEvents: 'none',
                        color: '#fff',
                    }}
                />
            )}
        </>
    );
};

export default SnowEffect;
